import { Component, ElementRef, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { FilterChip, FILTER_CHIPS } from 'src/app/enums & constants/filter-chips.constants';
import { MiradoresService } from 'src/app/services/miradores.service';
import { OrganizerService } from 'src/app/services/organizer.service';
import { MiradorFilter } from '../../models/mirador-filter';
import { IonRow } from '@ionic/angular';
import { AlbumsService } from 'src/app/services/albums.service';
import { Subject, takeUntil } from 'rxjs';

@Component({
  selector: 'app-filter-chips-album',
  templateUrl: './filter-chips-album.component.html',
  styleUrls: ['./filter-chips-album.component.scss']
})
export class FilterChipsAlbumComponent implements OnInit, OnDestroy {

  @ViewChild('chipsRow', { static: false }) containerRef: IonRow;

  allFilterChips: FilterChip[] = FILTER_CHIPS; /* JSON.parse(JSON.stringify(FILTER_CHIPS)); */
  filterBySearch: FilterChip = null;
  newFilterByList: FilterChip = null;

  @Output() filterChangeEvent: EventEmitter<FilterChip> = new EventEmitter();
  @Output() filterChangeCustomEvent: EventEmitter<FilterChip> = new EventEmitter();

  currentSelected: FilterChip;
  private unsubscribe$ = new Subject<void>();
  constructor(public ORGService: OrganizerService,
    private router: Router,
    private albumsService: AlbumsService) { }


  compareFn = (o1: any, o2: any) => (
    o1 && o2 ?
      o1.value === o2.value :
      o1 === o2);


  ngOnInit(): void {
    this.albumsService.$currentChipSelected
    .pipe(takeUntil(this.unsubscribe$))
    .subscribe((chipSelected) => {
      if (chipSelected) {
        this.currentSelected = chipSelected;
      }
    })

    this.ORGService.$shouldAppearFilterChipBySearch
    .pipe(takeUntil(this.unsubscribe$))
    .subscribe((filterChipBySearch) => {
      this.filterBySearch = filterChipBySearch;
      if (this.filterBySearch && this.currentSelected) {
        this.currentSelected.selected = false;
      }

    })

    this.ORGService.$shouldAppearNewFilterChipByList
    .pipe(takeUntil(this.unsubscribe$))
    .subscribe((newFilterChipByList) => {
      this.newFilterByList = newFilterChipByList;
      if (this.newFilterByList && this.currentSelected) {
        this.currentSelected.selected = false;
      }
    })
  }



  applyFilterChip(chip: FilterChip) {

    if (this.filterBySearch != null) {
      this.filterBySearch = null;
    }

    this.cambiarScrollHorizontal(0);
    this.albumsService.SetCurrentFilterChipSelected(chip);

    if (chip.type == 'Filter') {
      this.filterChangeEvent.emit(chip);
    } else {
      this.filterChangeCustomEvent.emit(chip)
    }
  }

  removeFilterSearch() {
    this.filterBySearch = null;
    this.filterChangeEvent.emit(null);
    this.ORGService.setFilterChipBySearch(null);
  }

  removeNewFilterByList() {
    this.newFilterByList = null;
    this.filterChangeEvent.emit(null);
    this.ORGService.setNewFilterChipByList(null);
  }

  goToLists() {
    this.router.navigate(['/app/explore']);
  }
  // setFilterToDefaultOne(){
  //   this.itemSelected = !!this.defaultItemSelected ? this.defaultItemSelected : this.listOfOption[0];
  //   this.isSelectionTheDefaultOne = true;
  // }

  // checkIsTheDefaultOne(select: FilterData){
  //   this.isSelectionTheDefaultOne = !!this.defaultItemSelected ? this.defaultItemSelected === select : this.listOfOption[0] === select;
  // }

  // setFilterTo(newFilterSelected: FilterData){
  //   this.itemSelected = newFilterSelected;
  // }

  getColor(chip) {

    if (chip.selected) {
      return 'selected'
    }

    if (chip.label === 'Todos') {
      return 'highlighted-chip'; // Agrega la clase de resaltado si la etiqueta es 'Todos'
    }

    if (chip.label === 'Experiencias') {
      return 'highlighted-chip-experiences';
    }

    return '';
  }

  isAllowChangeToDefault() {
    return this.newFilterByList == null;
  }

  cambiarScrollHorizontal(scrollPosition: number): void {
    const container: HTMLElement = this.containerRef['el'];

    container.scroll({ left: 0, behavior: 'smooth' });
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }
}
